'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const basis = '500px';
const shimmerKeyframes = keyframes(["0%{background-position:-", " 0;}100%{background-position:", " 0;}"], basis, basis);
const Wrapper = styled.div.withConfig({
  displayName: "ShimmerWrapper__Wrapper",
  componentId: "aspqfp-0"
})(["position:relative;"]);
const ShimmerLayer = styled.div.withConfig({
  displayName: "ShimmerWrapper__ShimmerLayer",
  componentId: "aspqfp-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient( 106deg,rgba(255,255,255,0.1) 20%,rgba(255,255,255,0.67) 35%,rgba(255,255,255,0.1) 67% );animation:", " 2400ms linear 0s infinite normal forwards;"], shimmerKeyframes);
const ShimmerWrapper = props => {
  const {
      children
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsxs(Wrapper, Object.assign({}, rest, {
    children: [children, /*#__PURE__*/_jsx(ShimmerLayer, {})]
  }));
};
ShimmerWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
export default ShimmerWrapper;